import { ITableColumn } from "@/types/ui"

export const getInitialColumns = <T>(defaultColumns: ITableColumn<T>[], localStorageKey: string): ITableColumn<T>[] => {
  const savedColumns = localStorage.getItem(localStorageKey)

  if (!savedColumns) {
    return defaultColumns
  }

  const savedColumnsParse = JSON.parse(savedColumns) as ITableColumn<T>[]

  return savedColumnsParse.map((column) => ({
    ...column,
    render: defaultColumns.find(c => c.key === column.key)?.render
  }))
}
